import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PreInitSettingsService } from 'src/app/core/services/settings/index';
import { CardDetails, PaymentPayload, LineItem, PaymentRequest, PaymentResponse } from 'src/app/model/payment/payment';
import { Tax } from 'src/app/model/payment/tax';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private middlewareUrl: string;
  private accountPath: string;
  constructor(
    private http: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
  ) {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.accountPath = this.preInitSettingsService.getSettings().middleWare.accountPath;
  }

  getPayload(planNumber: string): Observable<PaymentPayload> {
    return this.http.get<PaymentPayload>(`${this.middlewareUrl}${this.accountPath}payments-payload?planNumber=${planNumber}`);
  }

  getCardList(planNumber: string): Observable<Array<CardDetails>> {
    return this.http.get<Array<CardDetails>>(`${this.middlewareUrl}${this.accountPath}payments-card-list?planNumber=${planNumber}`);
  }

  getCard(planNumber: string, profileId: string): Observable<CardDetails> {
    return this.http.get<CardDetails>(`${this.middlewareUrl}${this.accountPath}payments-card?planNumber=${planNumber}&profileId=${profileId}`);
  }

  transaction(paymentRequest: PaymentRequest): Observable<PaymentResponse> {
    return this.http.post<PaymentResponse>(`${this.middlewareUrl}${this.accountPath}payments-transaction`, paymentRequest);
  }

  deleteCard(cardId: string, planNumber: string): Observable<void> {
    return this.http.delete<void>(`${this.middlewareUrl}${this.accountPath}payments-card?id=${cardId}&planNumber=${planNumber}`);
  }

  getPaymentsQuote(planNumber: string, productCodes: Array<string>, items: Array<LineItem>, dealerCode: string): Observable<Tax> {
    return this.http.post<Tax>(`${this.middlewareUrl}${this.accountPath}payments-quote`,{ planNumber, productCodes, items, dealerCode });
  }

  updateTransaction(id: string, isEdit: boolean): Observable<boolean> {
    return this.http.put<boolean>(`${this.middlewareUrl}${this.accountPath}update-transaction?id=${id}&isEdit=${isEdit}`, null);
  }

  setDefaultCard(cardId: string, planNumber: string): Observable<void> {
    return this.http.patch<void>(`${this.middlewareUrl}${this.accountPath}payments-default-card?id=${cardId}&planNumber=${planNumber}`, null);
  }

}
